import SimpleLightbox from 'simplelightbox';

export default class SingleProductGallery {
  constructor() {
    new SimpleLightbox('a.product-image', {
      captions: false,
    });
  }
}
